import { ExternalCmsSupported } from "libs/enum/src/lib/enum.common"

export interface TENANT_MODEL {
  id: number
  company_id: number
  created_by: number
  created_date: string
  updated_by: number
  updated_date: string
  name_primary_language: string
  name_secondary_language: string
  franchise_group_id: number
  franchise_group_primary_name: string
  franchise_group_secondary_name: string
  phone1_country_code: string
  phone1: string
  email_id: string
  website: string
  zone: string
  place_id: string
  latitude: number
  longitude: number
  city: string
  state: string
  zip_code: string
  ip_setting: string
  live_members: number
  image: string
  exclude_from_app: boolean
  primary_language: string
  secondary_language: string
  billing_name: string
  phone2_country_code: string
  phone2: string
  address: string
  country: string
  timezone: string
  timezone_value: string
  tax_number: string
  cin_ebn: string
  ff_subscription_id: string
  facebook_url: string
  twitter_url: string
  instagram_url: string
  status: string
  tenant_category_image: TenantCategoryImage
  is_paymentgateway_configured: boolean
  invoice_template_type: string
  payment_template_type: string
  external_cms_club_no: string
  tenant_start_date: string
  ext_cms_supported: ExternalCmsSupported
  country_name: string
  state_name: string
  city_name: string
  tenant_uuid: string
  external_cms_billing_no: number
}

export interface TenantCategoryImage {
  total_items: number
  base_url: string
  reception: string
  others: string[]
}

export interface ALL_TENANTS {
  items: Array<TENANTSINTERFACE>;
}
export interface TENANTSINTERFACE {
  accessed_tenant: Array<TENANT_MODEL>;
  all_tenant: Array<TENANT_MODEL>;
  selected_tenant: TENANT_MODEL;
}

export interface TENANTBYIDSTORE {
  tenant: TenantById
}

export interface TenantById{
  id: number;
  company_id: number;
  name_primary_language: string;
  name_secondary_language: string;
  phone1_country_code: string;
  phone1: string;
  email_id: string;
  website: string;
  zone: string;
  place_id: string;
  latitude: number;
  longitude: number;
  city: string;
  state: string;
  zip_code: string;
  ip_setting: string;
  live_members: number;
  image: string;
  exclude_from_app: boolean;
  primary_language: string;
  secondary_language: string;
  billing_name: string;
  phone2_country_code: string;
  phone2: string;
  address: string;
  country: string;
  timezone: string;
  timezone_value: string;
  tax_number: string;
  cin_ebn: string;
  ff_subscription_id: string;
  facebook_url: string;
  twitter_url: string;
  instagram_url: string;
  status: string;
  created_by: number;
  created_date: Date;
  updated_by: number;
  updated_date: Date;
  is_paymentgateway_configured:boolean;
  external_cms_club_no:string;
  tenant_start_date: string;
}

export interface TenantCategoryImage {
  total_items: number;
  base_url: string;
  reception: string;
  others: string[];
}

export interface TenantDetails {
  id: number;
  company_id: number;
  status: string;
  name_primary_language: string;
  name_secondary_language: string;
  primary_language: string;
  secondary_language: string;
  disabled:boolean;
}

export interface Franchise {
  franchise_group_id:number;
  franchise_group_primary_name:string;
  franchise_group_secondary_name:string;
}


export enum TenantStatus {
  InActive = 0,
  Active =1,
  PreSales =4
}



